module.exports = __webpack_public_path__ + "img/Dantam Makeover 29.57743239.jpg";